<cap-list-loader
  [defaultText]="'gemaessAmtlicherBewertung'"
  [hasRight]="true"
  [listLoader]="listLoader"
  [showTotal]="false"
  class="externe-daten">
  <div class="cap-list-loader-title">
    <ng-content select="[name=title]"></ng-content>
  </div>
  <div class="cap-list-loader-content">
    <table class="cap-table-detail">
      <thead>
        <ng-template [ngTemplateOutlet]="tableHeaders"></ng-template>
      </thead>
      <tbody>
        <ng-template [ngTemplateOutlet]="tableRows"></ng-template>
      </tbody>
    </table>
  </div>
</cap-list-loader>

<ng-template #tableHeaders>
  <tr>
    <th>{{ "Art" | translate }}</th>
    <th>{{ "Eigentumsform" | translate }}</th>
    <th>{{ "neskoab.AmtlicherWert" | translate }}</th>
    <th>{{ "Steuerjahr" | translate }}</th>
    <th>{{ "AnteilEigentum" | translate }}</th>
    <th>{{ "Grundstueck" | translate }}</th>
    <th>{{ "neskoab.Totalflaeche" | translate }}</th>
    <th>{{ "Wertquote" | translate }}</th>
  </tr>
</ng-template>

<ng-template #tableRows>
  @for (item of listLoader?.items; track item) {
    <tr>
      <td>
        @if (item.mBeziehungArt.access !== "NONE") {
          {{ item.beziehungArt | translate }}
        }
        @if (item.mBeziehungArt.access === "NONE") {
          <div class="mb-2">
            <span>{{ "gemaessAmtlicherBewertung" | translate }}</span>
          </div>
        }
      </td>
      <td>
        @if (item.mEigentumForm.access !== "NONE") {
          {{ item.eigentumForm | translate }}
        }
        @if (item.mEigentumForm.access === "NONE") {
          <div class="mb-2">
            <span>{{ "gemaessAmtlicherBewertung" | translate }}</span>
          </div>
        }
      </td>
      <td>
        @if (item.mAmtlicherWert.access !== "NONE") {
          @if (item.isAmtlicherWertVerteilt) {
            <span> ({{ item.amtlicherWert | betrag: true }}) {{ 0 | betrag: true }} </span>
          }
          @if (!item.isAmtlicherWertVerteilt) {
            <span>{{ item.amtlicherWert | betrag: true }}</span>
          }
          @if (item.isKennzeichnungErtragswert && item.amtlicherWert && !item.ertragswertNachBGBB) {
            <span>
              {{ "(mit Ertragswertkomponente)" | translate }}
            </span>
          }
        }
        @if (item.mAmtlicherWert.access === "NONE") {
          <div class="mb-2">
            <span>{{ "gemaessAmtlicherBewertung" | translate }}</span>
          </div>
        }
      </td>
      <td>
        @if (item.mGueltigAbSteuerjahr.access !== "NONE") {
          {{ item.gueltigAbSteuerjahr }}
        }
        @if (item.mGueltigAbSteuerjahr.access === "NONE") {
          <div class="mb-2">
            <span>{{ "gemaessAmtlicherBewertung" | translate }}</span>
          </div>
        }
      </td>
      <td>
        @if (item.mAnteilZaehler.access !== "NONE" || item.mAnteilNenner.access !== "NONE") {
          @if (item.anteilZaehler && item.anteilZaehler !== "0" && (item.anteilZaehler !== "1" || item.anteilNenner !== "1")) {
            <span> {{ item.anteilZaehler | decimalHochkomma }}/{{ item.anteilNenner | decimalHochkomma }} </span>
          }
        }
        @if (item.mAnteilZaehler.access === "NONE" || item.mAnteilNenner.access === "NONE") {
          <div class="mb-2">
            <span>{{ "gemaessAmtlicherBewertung" | translate }}</span>
          </div>
        }
      </td>
      <td>
        @if (item.mGrundstueckNummer.access !== "NONE") {
          {{ item.grundstueckNummer | grundstuecknummerExtended }}
        }
        @if (item.mGrundstueckNummer.access === "NONE") {
          <div class="mb-2">
            <span>{{ "gemaessAmtlicherBewertung" | translate }}</span>
          </div>
        }
      </td>
      <td>
        @if (item.mFlaeche.access !== "NONE") {
          @if (item.flaeche) {
            <span> {{ item.flaeche | decimalHochkomma }}&nbsp;m² </span>
          }
        }
        @if (item.mFlaeche.access === "NONE") {
          <div class="mb-2">
            <span>{{ "gemaessAmtlicherBewertung" | translate }}</span>
          </div>
        }
      </td>
      <td>
        @if (item.mDominierteGrundstuecke.access !== "NONE") {
          @if (item.dominierteGrundstuecke) {
            <span>
              {{ item.dominierteGrundstuecke.anteilZaehler | decimalHochkomma }}
              /{{ item.dominierteGrundstuecke.anteilNenner | decimalHochkomma }}
            </span>
          }
        }
        @if (item.mDominierteGrundstuecke.access === "NONE") {
          <div class="mb-2">
            <span>{{ "gemaessAmtlicherBewertung" | translate }}</span>
          </div>
        }
      </td>
    </tr>
  }
</ng-template>
